import { render, staticRenderFns } from "./RegisterTerms.vue?vue&type=template&id=25900cc7&scoped=true&"
import script from "./RegisterTerms.vue?vue&type=script&lang=js&"
export * from "./RegisterTerms.vue?vue&type=script&lang=js&"
import style0 from "./RegisterTerms.vue?vue&type=style&index=0&id=25900cc7&prod&scoped=true&lang=scss&"
import style1 from "./RegisterTerms.vue?vue&type=style&index=1&id=25900cc7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25900cc7",
  null
  
)

export default component.exports